export default __webpack_public_path__ + "static/media/secured@3x.7b21c7a0.png";